import React from 'react';
import {withSnackbar} from "notistack";
import { Link } from "react-router-dom";
import {forceLogout, getSchoolId, setSchoolAbbreviationName, setSchoolId} from "../../utils/authority";
import {isBrowser } from 'react-device-detect';
import UserController from "../../services/system/user/user-controller";
import {toast} from "react-toastify";
import AdSchoolInfoManager from "../../services/system/school-info/ad-school-info-manager";

class HeaderAfterLogin extends React.Component {

    static defaultProps = {
        account: {},
        isUploadDone: false,
        avatarInfo: {},
        isFetching: false,
    }

    constructor(props) {
        super(props);
        this.state = {
            avatar: null,
            userFullName: '',
            schoolName: '',
        }
    }
    componentDidMount() {
        this.getProfile()
        this.getListSchool()
    }
    getProfile() {
        UserController.detailSelf(res => {
            if (res.success) {
                let data = res.data;
                this.setState(
                    {
                        userFullName: data.fullName
                    }
                );
            } else {
                toast.error("Đã có lỗi xảy ra trong quá trình lấy dữ liệu, vui lòng tải lại trang!")
            }
        });
    };
    getListSchool = () => {
        let {pageNumber, pageSize} = this.state;
        let payload = {
            pageNumber: pageNumber,
            pageSize: pageSize,
            "sort": "created_at desc"
        };
        AdSchoolInfoManager.getListSchool(payload, res => {
            if (res.success && res.data.content.length > 0) {
                if (getSchoolId() == undefined){
                    setSchoolId(res.data.content[0].id)
                    setSchoolAbbreviationName(res.data.content[0].abbreviationName)
                }
                this.setState({
                    schoolId: res.data.content[0].id,
                    schoolName: res.data.content[0].name,
                });
            }else {
                toast.error("Có lỗi xảy ra 123!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    };
    render() {
        return (
            <div className="header-after-login-wrapper">
                <header className="affix header-after-login">
                    <div className="container pl-4 pr-4">
                        <nav className="navbar navbar-expand-lg navbar-light row">
                            <span className="navbar-brand col-9 d-flex">
                                <Link to="/" className="d-flex align-items-center col-md-1 col-2">
                                    <img src="/images/logo_sas.png" alt="" style={{width: 40}}/>
                                </Link>
                                <div className="col-md-3 col-4" style={{
                                    fontSize: "12px",
                                    justifyContent: "left"
                                }}>
                                    <div style={{color: "black"}}>{this.state.userFullName}</div>
                                    <div  style={{color: "#b00000", fontWeight: "bold"}}>{this.state.schoolName}</div>
                                </div>
                            </span>
                            <button className="navbar-toggler" type="button" data-toggle="collapse"
                                    data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                                    aria-expanded="false"
                                    aria-label="Toggle navigation"
                                    onClick={()=> this.props.toggleSidebarMobile()}
                            >
                                <span className="navbar-toggler-icon"/>
                            </button>
                            {isBrowser && <div className="sb-mb-logout d-flex justify-content-right align-items-center col-3" style={{
                                alignItems: "center",
                                justifyContent: "right"
                            }}>
                                <button type="button" className="btn btn-sm btn-outline-dark" onClick={forceLogout}>
                                    Đăng xuất
                                </button>
                            </div>}
                        </nav>
                    </div>
                </header>
            </div>
        );
    }
}

export default withSnackbar(HeaderAfterLogin);
